var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "inherit"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.25 12a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m14 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m-8.75 1.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5",
    clipRule: "evenodd"
  })));
};
export default SvgMore;